import {useTranslation} from 'next-i18next';
import {AddToCartErrorTypeEnum} from '@kidslabs/module-quote';
import {ConfigurableProductOptions} from '@/__generated__/__types__';

interface IProps {
    type: AddToCartErrorTypeEnum;
    unselectedOptions?: ConfigurableProductOptions[];
}

const ErrorAddToCartMessage: React.FC<IProps> = ({type, unselectedOptions}) => {
    const {t} = useTranslation('common');

    switch (type) {
        case AddToCartErrorTypeEnum.MISSING_SELECTED_VARIANT:
            return (
                <>
                    {unselectedOptions && unselectedOptions.length > 0 && (
                        <div className="text-[12px] text-red-500">
                            <span>{t('Dad/Mom, please choose')} </span>
                            {unselectedOptions.map((option, key) => (
                                <span key={key} className="lowercase">
                                    {t(`${option.attribute_code}`)}
                                    {key !== unselectedOptions.length - 1 ? ',' : ''}{' '}
                                </span>
                            ))}
                            <span className="lowercase"> {t('text-product')}</span>
                        </div>
                    )}
                </>
            );

        default:
            return <></>;
    }
};

export default ErrorAddToCartMessage;
